var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsUploadImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 63,
    viewBox: "0 0 76 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3413 26.7094L38.0438 29.9248C37.4942 30.4738 36.6306 30.3954 36.1595 29.768L27.9943 18.8668C27.4448 18.161 26.4241 18.2394 25.953 18.9452L12.6061 40.0418C12.0565 40.9045 12.6846 42.0024 13.7052 42.0024H44.0892C45.1884 39.2575 46.9156 36.9047 49.0354 35.101L43.2256 26.9447C42.7545 26.2388 41.8909 26.1604 41.3413 26.7094Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1049 21.3714C47.6631 21.3714 49.737 19.2998 49.737 16.7443C49.737 14.1888 47.6631 12.1172 45.1049 12.1172C42.5466 12.1172 40.4727 14.1888 40.4727 16.7443C40.4727 19.2998 42.5466 21.3714 45.1049 21.3714Z",
    fill: "#565656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9737 35.1035V3.02735C64.9737 1.92939 64.11 0.988281 62.9324 0.988281H2.55693C1.45776 0.988281 0.515625 1.85097 0.515625 3.02735V50.6319C0.515625 51.7298 1.37925 52.6709 2.55693 52.6709H47.3086C49.0358 58.5529 54.4531 62.8663 60.8911 62.8663C68.7422 62.8663 75.1017 56.5138 75.1017 48.6712C75.1017 42.3187 70.7835 36.8289 64.9737 35.1035ZM46.759 48.6712H4.51972V5.06643H60.8911V34.5546C53.1184 34.5546 46.759 40.9071 46.759 48.6712ZM65.8373 47.6517C65.5232 48.2007 64.9737 48.5928 64.3456 48.5928H62.6968V54.9453C62.6968 55.9648 61.9117 56.7491 60.8911 56.7491C59.8704 56.7491 59.0853 55.9648 59.0853 54.9453V48.5928H57.4366C56.8085 48.5928 56.2589 48.2791 55.9448 47.6517C55.6308 47.1027 55.7093 46.3969 56.1019 45.9263L59.5564 41.2992C59.8704 40.9071 60.3415 40.6718 60.8911 40.6718C61.4406 40.6718 61.9117 40.9071 62.2258 41.2992L65.6803 45.9263C66.0728 46.3969 66.1513 47.1027 65.8373 47.6517Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsUploadImg);
export default __webpack_public_path__ + "static/media/icons-upload-img.850c76cabfb39a4e4675e08ca45b9ebe.svg";
export { ForwardRef as ReactComponent };